import React, { useEffect, useState } from "react";
import styles from "./NotificationSettings.module.scss";
import CheckboxInput from "../../../components/controls/checkbox/Checkbox";
import { api } from "../../../store/services/auth.service";
import Skeleton from "react-loading-skeleton";
import DropDown from "../../../components/controls/dropdown/DropdownWithInput";

const NotificationSettings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [settings, setSettings] = useState([]);
  const deadlineOptions = [
    { name: "1 Day", offset: -1440 },
    { name: "1 Week", offset: -10080 },
  ];

  const taskOptions = [{ name: "Immediate", offset: 0 }];
  const unassignedTaskOptions = [
    { name: "Daily", offset: 0 },
    { name: "Weekly", offset: 1 },
  ];

  const handleGetNotification = () => {
    api.userNotificationSettings().then((res) => {
      if (res && res?.notifications?.length !== 0) {
        setSettings(res.notifications);
      }
      setIsLoading(false);
    });
  };

  const handleUpdateNotification = (type, status, value) => {
    const params = {
      type: type,
      isActive: status,
      offset: value,
    };
    api.updateNotificationSettings(params).then(() => {
      handleGetNotification();
    });
  };

  useEffect(() => {
    /*setIsLoading(true);
    handleGetNotification();*/
  }, []);

  return (
    <div className={`${styles.mainWrapper} font-family-imp`}>
      <h3>Notification Settings</h3>

      {isLoading ? (
        <div className={styles.notifyDetailContainer}>
          <Skeleton height={100} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
          <Skeleton height={100} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
          <Skeleton height={100} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
          <Skeleton height={100} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
          <Skeleton height={100} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
          <Skeleton height={100} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
        </div>
      ) : (
        <div className={styles.notifyDetailContainer}>
  {/* Project Rules */}
  <div className={styles.settingsCard}>
    <div className="d-flex align-items-start">
      <div className={styles.textContent}>
        <h6 className="font-weight-600 mb-1">
          Project Status Alerts <span class="pill purple ml-1">Enabled</span>
        </h6>
        <p className="text-xsm-400 subHeading-color">
          Sends immediate alert to project manager when a project enters Monitoring or Slipping.
        </p>
      </div>
    </div>
  </div>

  <div className={styles.settingsCard}>
    <div className="d-flex align-items-start">
      <div className={styles.textContent}>
        <h6 className="font-weight-600 mb-1">
          Project Budget Threshold Alerts <span class="pill purple ml-1">Enabled</span>
        </h6>
        <p className="text-xsm-400 subHeading-color">
          Notify the project manager when budget usage crosses key thresholds.
        </p>
      </div>
    </div>
  </div>

  <div className={styles.settingsCard}>
    <div className="d-flex align-items-start">
      <div className={styles.textContent}>
        <h6 className="font-weight-600 mb-1">
          Project Manager Change <span class="pill purple ml-1">Enabled</span>
        </h6>
        <p className="text-xsm-400 subHeading-color">
        Notify the project manager about new and updated role assignments.
        </p>
      </div>
    </div>
  </div>

  {/* Scope Rules */}
  <div className={styles.settingsCard}>
    <div className="d-flex align-items-start">
      <div className={styles.textContent}>
        <h6 className="font-weight-600 mb-1">
          Scope Status Alerts <span class="pill purple ml-1">Enabled</span>
        </h6>
        <p className="text-xsm-400 subHeading-color">
          Alerts when a scope enters Monitoring or Slipping states.
        </p>
      </div>
    </div>
  </div>

  {/* Risk Rules */}
  <div className={styles.settingsCard}>
    <div className="d-flex align-items-start">
      <div className={styles.textContent}>
        <h6 className="font-weight-600 mb-1">
          Risk and Issue Alerts <span class="pill purple ml-1">Enabled</span>
        </h6>
        <p className="text-xsm-400 subHeading-color">
          Sends alerts to the project manager and risk prime for all risk events with severity-based priority.
        </p>
      </div>
    </div>
  </div>

  <div className={styles.settingsCard}>
    <div className="d-flex align-items-start">
      <div className={styles.textContent}>
        <h6 className="font-weight-600 mb-1">
          Risk Ownership Changes <span class="pill purple ml-1">Enabled</span>
        </h6>
        <p className="text-xsm-400 subHeading-color">
          Notifies all parties when risk ownership changes.
        </p>
      </div>
    </div>
  </div>

  <div className={styles.settingsCard}>
    <div className="d-flex align-items-start">
      <div className={styles.textContent}>
        <h6 className="font-weight-600 mb-1">
          Risk Impact Date Reminders <span class="pill purple ml-1">Enabled</span>
        </h6>
        <p className="text-xsm-400 subHeading-color">
          Sends scheduled notifications to the project manager and risk prime before impact dates.
        </p>
      </div>
    </div>
  </div>

  {/* Task Rules */}
  <div className={styles.settingsCard}>
    <div className="d-flex align-items-start">
      <div className={styles.textContent}>
        <h6 className="font-weight-600 mb-1">
          Task Status Alerts <span class="pill purple ml-1">Enabled</span>
        </h6>
        <p className="text-xsm-400 subHeading-color">
          Alerts when tasks enter Monitoring or Slipping.
        </p>
      </div>
    </div>
  </div>
</div>
      )}
    </div>
  );
};

export default NotificationSettings;
